import { Spin } from 'antd';
import React, { Component } from 'react';
import './style.scss';

export class index extends Component {
  render() {
    return (
      <div className="loading-page">
        <Spin />
      </div>
    );
  }
}

export default index;
